<template>
	<div class="flex-1 display-flex flex-column">
		<div class="content-title">
			<h3 class="med">Choose {{ featureTypeText }} or create your own</h3>
		</div>
		<div class="pt-4 display-flex justify-content flex-wrap">
			<CreateYourOwnBox class="add-on-box flex-col-4" role="button" @click="chooseInstallable(null)" />
			<InstallableBox
				class="add-on-box listing flex-col-4"
				v-for="installable in installables"
				:key="installable.id"
				:installable="installable"
				@click="chooseInstallable(installable.id)"
			/>
		</div>
	</div>
</template>

<script>
import { indefinite } from '@/utils/language-service';
import CreateYourOwnBox from './CreateYourOwnBox.vue';
import InstallableBox from './InstallableBox.vue';

export default {
	name: 'ChooseInstallableForFeature',
	props: { featureType: { type: String, required: true }, installables: { type: Array } },
	components: { InstallableBox, CreateYourOwnBox },
	computed: {
		featureTypeText() {
			return indefinite(this.featureType);
		},
	},
	methods: {
		chooseInstallable(installableId) {
			this.$emit('choose', installableId);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/components/CreationWizard/assets/creation-wizard-vars.scss';
.content-title {
	h3 {
		color: #303133;
	}
}
.add-on-box {
	height: $box-height;
	border-radius: $border-radius;
	margin: $vertical-margin $horizontal-margin;
	&.listing {
		border: 1px dashed black; // for now
	}
}
</style>
